import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module core/multicommand
 */
import Command from './command.js';
import { insertToPriorityArray } from '@ckeditor/ckeditor5-utils';
/**
 * A CKEditor command that aggregates other commands.
 *
 * This command is used to proxy multiple commands. The multi-command is enabled when
 * at least one of its registered child commands is enabled.
 * When executing a multi-command, the first enabled command with highest priority will be executed.
 *
 * ```ts
 * const multiCommand = new MultiCommand( editor );
 *
 * const commandFoo = new Command( editor );
 * const commandBar = new Command( editor );
 *
 * // Register a child command.
 * multiCommand.registerChildCommand( commandFoo );
 * // Register a child command with a low priority.
 * multiCommand.registerChildCommand( commandBar, { priority: 'low' } );
 *
 * // Enable one of the commands.
 * commandBar.isEnabled = true;
 *
 * multiCommand.execute(); // Will execute commandBar.
 * ```
 */
var MultiCommand = /*#__PURE__*/function (_Command) {
  _inherits(MultiCommand, _Command);
  var _super = _createSuper(MultiCommand);
  function MultiCommand() {
    var _this;
    _classCallCheck(this, MultiCommand);
    _this = _super.apply(this, arguments);
    /**
     * Registered child commands definitions.
     */
    _this._childCommandsDefinitions = [];
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(MultiCommand, [{
    key: "refresh",
    value: function refresh() {
      // Override base command refresh(): the command's state is changed when one of child commands changes states.
    }
    /**
     * Executes the first enabled command which has the highest priority of all registered child commands.
     *
     * @returns The value returned by the {@link module:core/command~Command#execute `command.execute()`}.
     */
  }, {
    key: "execute",
    value: function execute() {
      var command = this._getFirstEnabledCommand();
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return !!command && command.execute(args);
    }
    /**
     * Registers a child command.
     *
     * @param options An object with configuration options.
     * @param options.priority Priority of a command to register.
     */
  }, {
    key: "registerChildCommand",
    value: function registerChildCommand(command) {
      var _this2 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      insertToPriorityArray(this._childCommandsDefinitions, {
        command: command,
        priority: options.priority || 'normal'
      });
      // Change multi-command enabled state when one of registered commands changes state.
      command.on('change:isEnabled', function () {
        return _this2._checkEnabled();
      });
      this._checkEnabled();
    }
    /**
     * Checks if any of child commands is enabled.
     */
  }, {
    key: "_checkEnabled",
    value: function _checkEnabled() {
      this.isEnabled = !!this._getFirstEnabledCommand();
    }
    /**
     * Returns a first enabled command with the highest priority or `undefined` if none of them is enabled.
     */
  }, {
    key: "_getFirstEnabledCommand",
    value: function _getFirstEnabledCommand() {
      var commandDefinition = this._childCommandsDefinitions.find(function (_ref) {
        var command = _ref.command;
        return command.isEnabled;
      });
      return commandDefinition && commandDefinition.command;
    }
  }]);
  return MultiCommand;
}(Command);
export { MultiCommand as default };